import { FC, memo } from 'react';
import { Text, TypographyHorizontalAlign } from '@picsart/text';
import Grid from '@picsart/grid/Grid';
import { Backgrounds, ScreenSizes, Spacings, Texts, Typography } from '@picsart/cascade';
import { useTranslator } from '@picsart/rc/services/localization';
import View from '@picsart/view/View';
import classNames from 'classnames';
import useMount from '@picsart/rc/useMount';

import analytics, { SubToolNames } from 'pages/Batch/utils/analytics';
import { BATCH_TOOLS } from 'pages/Batch/configs';
import { WatermarksPositions } from 'pages/Batch/utils/watermark/configs';
import dynamicTestId from 'utils/common/dynamicTestId';

import { WatermarkPositionsIconList } from '../constants';
import useStyles from '../styles';
import testIds from '../testIds';

type WatermarkPositionProps = {
  selectedPosition: WatermarksPositions | null;
  selectedLogoId: string | null;
  handleChange: (id: WatermarksPositions) => void;
}

const WatermarkPosition: FC<WatermarkPositionProps> = ({ selectedPosition, handleChange, selectedLogoId }) => {
  const classes = useStyles();
  const translate = useTranslator();
  const disabled = !selectedLogoId;

  useMount(() => {
    analytics.utils().setSubTool(BATCH_TOOLS.watermark, {
      name: SubToolNames.position,
      value: WatermarkPositionsIconList[0].id,
    });
  });

  return (
    <View
      flexDirection="column"
      className={classNames({
        [classes.disabledState]: disabled,
      })}
    >
      <Text size={Typography.t4} color={Texts.base} align={TypographyHorizontalAlign.Left}>{translate('Position')}</Text>
      <Grid
        columns={{
          [ScreenSizes.LG]: 'repeat(4, 1fr)',
          [ScreenSizes.SM]: 'repeat(6, 1fr)',
        }}
        gap={Spacings.s8}
      >
        {WatermarkPositionsIconList.map(({ icon: IconElement, id, name }) => (
          <View
            key={id}
            dataTestId={dynamicTestId(testIds.position, name)}
            backgroundColor={selectedLogoId && selectedPosition === id ? Backgrounds.tint4 : ''}
            disabled={disabled}
            justifyContent="center"
            alignItems="center"
            height={Spacings.s48}
            width={Spacings.s48}
            onClick={() => handleChange(id)}
          >
            <IconElement
              className={classes.iconSizeSmall}
              id={id}
            />
          </View>
        ))}
      </Grid>
    </View>
  );
};

export default memo(WatermarkPosition);
